import { useLocation, useNavigate } from 'react-router-dom';

type Props = {
  defaultPath?: string;
};

export const useNavigateBack = ({ defaultPath }: Props = {}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      if (defaultPath) {
        navigate(defaultPath);
      }
    }
  };

  return {
    goBack,
  };
};
